export default "__VITE_PUBLIC_ASSET__3e02a2d3__"